import React from "react";
import HSelect from "../../../components/custom/input/select/Select";

const DepartmentId = (props) => {
  const { departmentsList, departmentId, selectedNumberData, setDepartmentId } = props;

  const handlePhoneNumberDepartmentAssociation = (departmentId) => {
    setDepartmentId(departmentId);
  };

  return (
    <div>
      {departmentsList?.length > 0 && (
        <>
          <div className="editPhoneLabel">
            <>
              <HSelect
                label="Department ID"
                placeholder="Choose Department"
                customProps={{
                  value: departmentId || selectedNumberData?.departmentId,
                  onSelect: (departmentId) => {
                    handlePhoneNumberDepartmentAssociation(departmentId);
                  },
                }}
                className="w-50"
                value={selectedNumberData?.departmentId}
                options={departmentsList?.map((department) => {
                  return {
                    label: department.name,
                    value: department.id,
                  };
                })}
              />
            </>
          </div>
        </>
      )}
    </div>
  );
};

export default DepartmentId;
